import React from "react";

export const AavoContextMenuClosingContext = React.createContext<
	AavoContextMenuClosingContextValue | undefined
>(undefined);

export interface AavoContextMenuClosingContextValue {
	closeContextMenu: () => void;
}
